import { withStyles } from "@material-ui/core";
import styles from "../styles";
import HolidayGrid from "./HolidayGrid/index";

const HolidayManagement = (props) => {
  const { classes } = props;
  return (
    <>
      <header className={`${classes.moduleHeader} ${classes.transition}`}>
        Holiday Management
      </header>
      <HolidayGrid />
    </>
  );
};

export default withStyles(styles)(HolidayManagement);
